import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import Nosotros from './pages/Nosotros/Nosotros';
import Contacto from './pages/Contacto/Contacto';
import Marcas from './pages/Marcas/Marcas';
import BrandProducts from './pages/Marcas/BrandProducts';
import SearchResults from './pages/Search/SearchResults';
import Login from './pages/Login/Login';
import Backoffice from './pages/Backoffice/Backoffice';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import './App.css';

function App() {
  useEffect(() => {
    // --- SEO: Google Search Console ---
    // Inyectar meta etiqueta de verificación para que Google indexe el sitio
    if (!document.querySelector('meta[name="google-site-verification"]')) {
      const meta = document.createElement('meta');
      meta.name = "google-site-verification";
      meta.content = "TU_CODIGO_AQUI"; // <--- REEMPLAZA ESTO CON TU CÓDIGO DE GOOGLE
      document.head.appendChild(meta);
    }

    // --- SEO: Google Analytics (Opcional) ---
    // Si también tienes el código de Analytics (G-XXXXXXXXXX), descomenta esto:
    /*
    const script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX";
    script.async = true;
    document.head.appendChild(script);
    
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-XXXXXXXXXX');
    */
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/backoffice/*" element={
            <ProtectedRoute>
              <Backoffice />
            </ProtectedRoute>
          } />
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="nosotros" element={<Nosotros />} />
            <Route path="contacto" element={<Contacto />} />
            <Route path="marcas" element={<Marcas />} />
            <Route path="marcas/:brandId" element={<BrandProducts />} />
            <Route path="buscar" element={<SearchResults />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
